import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Home } from './components/Home';
import BoardListing from './components/BoardListing';
import UserListing from './components/UserListing';
import GroupListing from './components/GroupListing';
import GigsByFilter from './components/GigsByFilter';
import { MyBoardsWithBuckets } from './components/MyBoardsWithBuckets';
import Me from './components/Me';
import { SignInForm } from './components/SignInForm';
import { Header } from './components/Header';
import { PrivateRoute } from './PrivateRoute';

import { MuiThemeProvider } from '@material-ui/core/styles';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './constants';
import { FeatureFlagProvider } from './contexts/feature-flag-context';
import { PHProvider } from './contexts/posthog-context';
import { UserProvider } from './contexts/user-context';
import { theme } from './theme';

import './App.css';

const ContextWrappers = ({ children }) => (
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <UserProvider>
      <PHProvider>
        <FeatureFlagProvider>{children}</FeatureFlagProvider>
      </PHProvider>
    </UserProvider>
  </GoogleOAuthProvider>
);

export const App = () => {
  return (
    <ContextWrappers>
      <Router>
        <MuiThemeProvider theme={theme}>
          <Header />
          <Routes>
            <Route
              exact
              path="/"
              element={<PrivateRoute component={Home} />}
            />
            <Route
              exact
              path="/boards/:boardId"
              element={<PrivateRoute component={MyBoardsWithBuckets} />}
            />
            <Route
              exact
              path="/boards"
              element={<PrivateRoute component={BoardListing} />}
            />
            <Route
              exact
              path="/gigsByFilter/:filter"
              element={<PrivateRoute component={GigsByFilter} />}
            />
            <Route
              exact
              path="/bucketsByPriority/:priority"
              element={<PrivateRoute component={MyBoardsWithBuckets} />}
            />
            <Route
              exact
              path="bucketsByPriority/:priority/:rule"
              element={<PrivateRoute component={MyBoardsWithBuckets} />}
            />
            <Route exact path="/me" element={<PrivateRoute component={Me} />} />
            <Route
              exact
              path="/users/"
              element={
                <PrivateRoute
                  component={UserListing}
                  requiredRoles={['admin', 'dashboard_admin']}
                />
              }
            />

            <Route
              exact
              path="/groups/"
              element={
                <PrivateRoute
                  component={GroupListing}
                  requiredRoles={['admin', 'dashboard_admin']}
                />
              }
            />

            <Route exact path="/signin" element={<SignInForm />} />
            <Route render={() => <div>404</div>} />
          </Routes>
        </MuiThemeProvider>
      </Router>
    </ContextWrappers>
  );
};
